import { render } from "./MaterialSelector.vue?vue&type=template&id=394202cf&scoped=true&ts=true"
import script from "./MaterialSelector.vue?vue&type=script&lang=ts"
export * from "./MaterialSelector.vue?vue&type=script&lang=ts"

import "./MaterialSelector.vue?vue&type=style&index=0&id=394202cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394202cf"]])

export default __exports__